import { TabIMFormStyled } from 'components/common/initiate-proposal/styles';
import styled from 'styled-components';

export const IMFormStyled = styled(TabIMFormStyled)`
  min-height: 25rem;
`;
